import React from 'react';
import { Link } from 'react-router-dom';
const Intro = () => {
  const businessImg = "/images/BG_Transparent.png";

  return (
    <section className='relative overflow-hidden min-h-[90vh] md:min-h-screen flex items-center justify-center py-12 md:py-20 -mt-20'>
      
      {/* 1. Background Incliné (Stylisé via index.css) */}
      <div className='ueber_uns-Intro'></div>

      {/* 2. Conteneur de Contenu - Structure Grid pour un contrôle total */}
      <div className='relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12'>
        <div className='flex flex-col md:flex-row items-center justify-between gap-10 lg:gap-20'>
          
          {/* BLOC GAUCHE : Texte avec hiérarchie visuelle */}
          <div className='w-full md:w-1/2 space-y-6 md:space-y-8 text-center md:text-left pt-10 md:pt-0'>
            <div className='inline-block px-4 py-2 bg-primary/10 rounded-full'>
               <span className='text-primary font-bold tracking-widest text-xs md:text-sm uppercase'>Web-Exzellenz</span>
            </div>
            
            <div className='space-y-4'>
              {/* Ajustement de la taille du texte et retrait de whitespace-nowrap pour éviter le débordement */}
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-black text-secondary uppercase tracking-tighter leading-[1.1] md:leading-none">
                Mesmin Vision <span className="text-primary block sm:inline">Digital Services</span>
              </h1>
              <div className='w-20 md:w-24 h-2 bg-primary mx-auto md:mx-0 rounded-full'></div>
            </div>

            {/* Slogan : Changement de whitespace-nowrap vers normal pour mobile */}
            <p className="text-slate-700 text-lg md:text-xl font-semibold leading-snug tracking-wide opacity-90 italic">
              ERFAHRENER | STÄRKER | KLÜGER
            </p>

            <div className="pt-6">
              <Link to="/kontakte"> 
                <button className="
                  relative overflow-hidden group
                  w-full sm:w-auto 
                  bg-secondary text-white 
                  px-10 py-4 rounded-xl 
                  font-black uppercase tracking-[0.15em] text-sm
                  transition-all duration-500 
                  hover:scale-105 hover:shadow-[0_20px_40px_rgba(147,51,234,0.3)]
                  active:scale-95
                ">
                  {/* Effet de brillance au survol */}
                  <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] transition-transform"></span>
                  
                  <span className="relative z-10 flex items-center justify-center gap-3">
                    Projekt starten
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-2" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M14 5l7 7m0 0l-7 7m7-7H3" 
                      />
                    </svg>
                  </span>
                </button>
              </Link>
            </div>
          </div>

          {/* BLOC DROIT : Image avec effet de lévitation */}
          <div className='w-full md:w-1/2 flex justify-center md:justify-end mt-8 md:mt-0'>
            <div className='relative group w-full max-w-[320px] sm:max-w-md md:max-w-lg'>
              {/* Halo décoratif derrière l'image */}
              <div className='absolute inset-0 bg-primary/20 blur-3xl rounded-full scale-75 group-hover:scale-110 transition-transform duration-700'></div>
              
              <img 
                src={businessImg} 
                alt="Marketing Agency Illustration" 
                className="relative z-10 w-full h-auto object-contain drop-shadow-2xl animate-float"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
);
};

export default Intro